import React, { Fragment } from 'react';
import { ListItemText, ListItemButton, ListItemIcon, Collapse } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import { AuthCompanyContext, useHasRole } from '@homesusa/auth';
import { AppContext } from '../../contexts';
import { SubMenuProps } from '../../interfaces';
import { SubMenuItems } from './submenu-items.components';

const itemIconSpacing = 7;
export function SubMenu({ items: propsItems, icon: Icon, ...props }: SubMenuProps): JSX.Element {
  const {
    appState: {
      layout: {
        sidebar: { openSubSidebar }
      }
    },
    appStateDispatch
  } = React.useContext(AppContext);
  const { currentMarket } = React.useContext(AuthCompanyContext);
  const { hasUserRole } = useHasRole();
  const [open, setOpen] = React.useState(true);

  const handleClick = (): void => {
    setOpen(!open);
    if (!openSubSidebar) {
      appStateDispatch({ type: 'OpenSubSideBar' });
    }
  };

  const menuItems = React.useMemo(
    () =>
      propsItems?.filter(
        (x) =>
          (x.filterByMarket == null ||
            x.filterByMarket.length === 0 ||
            x.filterByMarket.includes(currentMarket)) &&
          (x.allowedUserRoles == null ||
            x.allowedUserRoles.length === 0 ||
            hasUserRole(x.allowedUserRoles))
      ) ?? [],
    [propsItems, currentMarket, hasUserRole]
  );
  const haveItems = menuItems.length > 0;
  const listButtonProps = {
    ...(haveItems && { onClick: handleClick }),
    ...(!haveItems &&
      (!!props.externalEndpoint
        ? {
            onClick: () => window.open(props.endpoint, '_blank', 'noopener,noreferrer')
          }
        : { component: RouterLink, to: props.endpoint ?? '/' }))
  };

  const CollapsableIcon = () =>
    open ? (
      <ExpandLess sx={{ color: 'primary.dark' }} />
    ) : (
      <ExpandMore sx={{ color: 'primary.dark' }} />
    );

  React.useEffect(() => {
    if (!openSubSidebar && open) {
      setOpen(false);
    }
  }, [openSubSidebar, open]);

  return (
    <Fragment>
      <ListItemButton {...listButtonProps}>
        <ListItemIcon sx={{ minWidth: (theme): string => theme.spacing(itemIconSpacing) }}>
          <Icon />
        </ListItemIcon>
        <ListItemText
          primary={props.title}
          primaryTypographyProps={{
            sx: {
              textTransform: 'uppercase',
              color: 'primary.dark',
              fontWeight: 'bold'
            }
          }}
        />
        {haveItems && <CollapsableIcon />}
      </ListItemButton>
      {haveItems && (
        <Collapse in={open} timeout='auto' unmountOnExit>
          <SubMenuItems items={menuItems} />
        </Collapse>
      )}
    </Fragment>
  );
}
